import { N66 } from "./SalesSummaryPerProductGroup/N66"

export const RegionPerformanceByProductGroup = {
  "sections": [
    N66
  ]
}